import Vue from 'vue';

import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.min.css';

const defaultOptions = {
  theme: 'dark',
  progressBar: false,
  close: false,
};

Vue.use(VueIziToast, defaultOptions);
